import memoize from "lodash.memoize";

const createSelectorsFor = domain => {
  const getDisplayingRows = state => state.pagination[domain].displayingRows;
  const getDisplayOptions = state => state.pagination[domain].displayOptions;
  const getActivePage = state => state.pagination[domain].activePage;
  const getStartPage = state => state.pagination[domain].startPage;
  const getEndPage = state => state.pagination[domain].endPage;
  const hasNextPage = state => state.pagination[domain].hasNextPage;
  const hasPrevPage = state => state.pagination[domain].hasPrevPage;
  const getVisiblePages = state => state.pagination[domain].visiblePages;
  const getTotalRows = state => state.pagination[domain].totalRows;
  const getTotalPages = state => {
    const displayingRows = getDisplayingRows(state);
    const totalRows = getTotalRows(state);
    return Math.ceil(totalRows / displayingRows);
  };

  return {
    getDisplayingRows,
    getDisplayOptions,
    getActivePage,
    getStartPage,
    getEndPage,
    hasNextPage,
    hasPrevPage,
    getVisiblePages,
    getTotalPages,
    getTotalRows
  };
};

export const selectorsFor = memoize(createSelectorsFor);
